import { useCallback, useEffect, useRef, useState } from 'react';
export function useEyeMove({
  leftEye,
  rightEye
}) {
  const svg = useRef(null);
  const movingFactorX = 0.007;
  const movingFactorY = 0.005;
  const [translatedLeftEye, setTranslatedLeftEye] = useState({
    x: 0,
    y: 0
  });
  const [translatedRightEye, setTranslatedRightEye] = useState({
    x: 0,
    y: 0
  });
  const mouseMoved = useCallback(ev => {
    if (!svg.current) {
      return;
    }
    const containerBounds = svg.current.getBoundingClientRect();
    const positionInContainer = {
      x: ev.pageX - containerBounds.x,
      y: ev.pageY - containerBounds.y
    };
    const positionToLeftEye = {
      x: positionInContainer.x - leftEye.x,
      y: positionInContainer.y - leftEye.y
    };
    const positionToRightEye = {
      x: positionInContainer.x - rightEye.x,
      y: positionInContainer.y - rightEye.y
    };
    setTranslatedLeftEye({
      x: positionToLeftEye.x * movingFactorX,
      y: positionToLeftEye.y * movingFactorY
    });
    setTranslatedRightEye({
      x: positionToRightEye.x * movingFactorX,
      y: positionToRightEye.y * movingFactorY
    });
  }, [leftEye.x, leftEye.y, rightEye.x, rightEye.y]);
  useEffect(() => {
    document.addEventListener('mousemove', mouseMoved);
    return () => document.removeEventListener('mousemove', mouseMoved);
  }, [mouseMoved]);
  return {
    svg,
    translatedLeftEye,
    translatedRightEye
  };
}